import React, { useEffect, useState } from 'react'

import { pxToRem } from '@/shared/styles/themes'
import { Box, styled } from '@mui/material'

export const ReadingProgressBar: React.FC = () => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const docHeight = document.documentElement.scrollHeight - window.innerHeight

      if (docHeight > 0) {
        setProgress(Math.min(scrollTop / docHeight, 1))
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <ProgressTrack>
      <ProgressFill style={{ transform: `scaleX(${progress})` }} />
    </ProgressTrack>
  )
}

const ProgressTrack = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: pxToRem(3),
  zIndex: 1201,
  backgroundColor: 'transparent',
  pointerEvents: 'none',
})

const ProgressFill = styled(Box)(({ theme }) => ({
  height: '100%',
  backgroundColor: '#4A7FA5',
  transformOrigin: 'left',
  willChange: 'transform',
}))
